<template>
  <div id="lines" :class="this.$lang === 'ar' ? 'regular-ar' : 'regular-en'">
    <div class="header-container">
      <div class="inner-container d-flex">
        <div class="header-titles">
          <div class="header-data">
            <div :class="['header-title', this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en']">{{$t('products.toolbar.lines.header')}}</div>
            <div class="description ">{{$t('products.toolbar.lines.desc')}}</div>
          </div>
        </div>
        <img :class="[this.$lang === 'ar' ? 'right' : 'right', 'header-img d-block']" src="../../assets/images/mtnLine.png" class="internationalIcon">
        <div v-observe-visibility="visibilityChanged"></div>
        <div class="lottie">
          <vue-lottie-player :key="key"  name="anime" ref="lottie" width="100%" height="100%" style="position: absolute; left: 0px; top: -25px" :animationData="jsonFile" />
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="content-header">
        <div :class="[this.$lang === 'ar' && 'rotate right-dir', 'tabs-container']" style="width: 100%">
          <v-tabs
            v-model="tab"
            grow
            centered
            show-arrows
            class="line-tabs left-dir"
          >
            <v-tabs-slider color="#FFCB05" ></v-tabs-slider>
            <v-tab
              v-for="item in info.items" :key="item.title" :active-class="lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">{{ item.title }}
            </v-tab>
          </v-tabs>
        </div>
      </div>
      <v-tabs-items v-model="tab" :touchless="true">
        <div class="products-container">
          <v-tab-item v-for="item in info.items" :key="item.title">
            <component :is="item.comp" />
          </v-tab-item>
        </div>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import PrePaid from './PrePaid'
import PostPaid from './PostPaid'
import $ from 'jquery'
import json from '../../assets/json/mtnLine.json'
import VueLottiePlayer from 'vue-lottie-player'
export default {
  components: { PrePaid, PostPaid, VueLottiePlayer },
  data () {
    return {
      tab: null,
      info: { items: [{ title: this.$t('products.toolbar.pre'), comp: 'PrePaid', path: 'prepaid-lines' }, { title: this.$t('products.toolbar.post'), comp: 'PostPaid', path: 'postpaid-lines' }] },
      activeTab: '',
      lang: this.$lang,
      desc: 'The Postpaid Line Gives You The Opportunity To Talk Freely Without The Need To Repeatedly Recharge Your Balance Also You Can Subscribe To Tariff Bundles Designed Specially To Accommodate The Needs Of Customers.',
      jsonFile: json,
      key: 0
    }
  },
  methods: {
    visibilityChanged (isVisible) {
      if (isVisible) {
        this.key++
        this.$forceUpdate()
      }
    }
  },
  mounted () {
    this.tab = Number(this.$route.params.type)
    this.$lang === 'ar' && $('#lines .v-tab').css('transform', 'rotateY(180deg)')
  },
  watch: {
    tab (val) {
      this.$store.state.productsInnerTab = val
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/sass/modules/products";
.main-content {
  background: rgba(242,242,242, 0.6);
}
.header-container{
  width: 100%;
  min-height: 350px;
  text-align: initial;
  position: relative;
  z-index: 0;
}
.inner-container{
  background: linear-gradient(45deg , rgba(255,203, 5, 1 ), rgba(255,203, 5, .5 ));
  min-height: 350px;
  //padding-bottom: 40px;
  position: relative;
  z-index: -2;
  .header-titles{
    width: 50%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 40px;
    .header-data {
      text-align: center;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px 0
    }
    .header-title{
      color: #fff;
      font-size: 30px;
    }
  }
}
.inner-container .header-titles {
  margin-top: 70px;
  padding: 0 4vw;
}
.header-img{
  /*width:364px;*/
  /*height: 400px;*/
  height:100%;
  display: inline-block;
  position: absolute;
  bottom: 0px;
  z-index: 1;
}
#lines .header-img {
  width: auto;
  height: auto;
  left: -45px;
}
/*@media (max-width: 1230px) {*/
/*  img.header-img {*/
/*    height: 300px;*/
/*    width: 300px;*/
/*    bottom: 0;*/
/*    top: unset;*/
/*  }*/
/*}*/
@media screen and (max-width: 1280px){
  #lines .header-img, .lottie{
    display: none !important;
  }
}
@media screen and (max-width: 1000px){
  .description{
    padding-bottom: 0px;
  }
  .header-titles{
    width: 90% !important;
  }
  .header-data {
    text-align: center;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0
  }
  /*img.header-img{*/
  /*  display: none !important;*/
  /*}*/
}
</style>
<style lang="scss">
#lines{
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active){
    color: rgba(29, 29, 29, 0.6) !important;
  }
  .v-tabs{
    height: 100%;
    border-bottom: none !important;
  }
  .v-tab{
    font-size: 12px !important;
    border-bottom: 2px solid #ffffff;
    text-transform: capitalize;
  }
  .v-tab.v-tab--active{
    color: #FFCB05;
  }
  .v-window.v-item-group.theme--light.v-tabs-items{
    background: transparent;
  }
}
</style>
